import * as c from '../constants';


const INIT_STATE = {
  type: c.TYRO_STATUS_MESSAGE,
  message: "Processing",
  options: []
}


export default function TyroStatusReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case c.TYRO_RESET_STATUS: {
      return INIT_STATE;
    }

    case c.TYRO_SET_MESSAGE_STATUS: {
      return {
        ...state,
        type: c.TYRO_STATUS_MESSAGE,
        message: action.payload
      }
    }

    case c.TYRO_SET_ERROR_STATUS: {
      return {
        ...state,
        type: c.TYRO_STATUS_ERROR,
        message: action.payload
      }
    }

    case c.TYRO_SET_QUESTION_STATUS: {
      const { message, options } = action.payload;

      return {
        ...state,
        message,
        options,
        type: c.TYRO_STATUS_QUESTION
      }
    }

    default: {
      return state;
    }
  }
}